import { ComponentProps } from 'react';

import { isDefined } from './is-defined';
import { SEO } from './Seo';

export default function mapPageMetadata(input?: {
  metaTags?: Array<MetatagsFragment | undefined>;
}): ComponentProps<typeof SEO> {
  if (input && input.metaTags) {
    const title = input.metaTags
      .filter(isDefined)
      .filter(
        ({ tag, attributes }) => tag === 'meta' && attributes?.name === 'title',
      )
      .pop();

    const links = input.metaTags
      .filter(isDefined)
      .filter(
        ({ tag, attributes }) =>
          tag === 'link' && attributes?.rel !== 'shortlink',
      );

    const meta = input.metaTags
      .filter(isDefined)
      .filter(({ tag }) => tag === 'meta');

    return {
      title: title?.attributes?.content,
      links: links.map(({ attributes }) => ({
        rel: attributes?.rel || '',
        href: attributes?.href || '',
      })),
      meta: meta.map(({ attributes }) =>
        attributes?.property
          ? {
              property: attributes?.property || '',
              content: attributes?.content || '',
            }
          : {
              name: attributes?.name || '',
              content: attributes?.content || '',
            },
      ),
    };
  } else {
    return { links: [], meta: [], title: undefined };
  }
}
